<div class="row m-0 p-0">
  <div class="col-sm-8 mb-1 fw-bold">
    <span *ngIf="openedFrom === 'SHIPPER'">
      {{ 'address.searchList.searchShipperAddress' | translate }}
    </span>

    <span *ngIf="openedFrom === 'RECEIVER'">
      {{ 'address.searchList.searchReceiverAddress' | translate }}
    </span>
  </div>
  <div class="col-sm-4 text-end">
    <em class="bi bi-x-lg" mat-dialog-close></em>
  </div>
  <div class="col-12 mt-2 mb-2 search-bar-group">
    <input
      matInput
      class="input-search"
      [formControl]="searchKeywordFilter"
      placeholder="{{ 'address.searchList.search' | translate }}" />
  </div>

  <div class="col-12" *ngIf="searchItems.length === 0 || !searchItems">
    {{ 'address.searchList.noAddressFound' | translate }}
  </div>

  <div class="custom-card">
    <div class="col-12 table-container">
      <table aria-label="addresslist" mat-table matSort [dataSource]="dataSource">
        <th></th>
        <ng-container matColumnDef="NickName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'address.searchList.nickName' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.nickName }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="CompanyName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'address.searchList.company' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.companyName }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="ContactPersonName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'address.searchList.contactPerson' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.contactPersonName }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="AddressLine1">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'address.searchList.addressLine1' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.addressLine1 }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="CityName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'address.searchList.city' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.cityName }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="PostalCode">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'address.searchList.postalCode' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.postalCode }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="CountryCode">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'address.searchList.countryCode' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.countryCode }}</mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row
          matRipple
          *matRowDef="let row; columns: displayedColumns"
          (click)="selectedAddress(row?.address_id)"
          class="cursor-pointer"></mat-row>
      </table>
      <mat-paginator
        [pageSize]="15"
        #paginator
        [length]="totalData"
        [pageSizeOptions]="pageSizes"
        showFirstLastButtons></mat-paginator>
    </div>
  </div>
</div>
